  <div class="container">
    <app-header>
    </app-header>

    <div class="content" style="margin-top: 54px;">
      <ng-content></ng-content>
    </div>

    <ng-content select="app-footer"></ng-content>
  </div>
